import React from "react";
const param = {
    category:"",
    keyword:"",
    location:"",
    lang:"en"
}

export const ParamContext = React.createContext(param);